// ** React Imports
import { matchPath, useLocation } from "react-router-dom";
import { renderRoutes } from "react-router-config";

// ** Redux & Store & Actions
import { connect, useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Nav from "components/layout/Nav";
import NavItemLink from "components/base/NavItemLink";
import Block from "components/layout/Block";
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";
import { CardsBlockWrapper } from "components/layout/Card/CardsBlockWrapper";
import EmptyBlock from "components/layout/Block/BlockEmpty";

// ** Utils & Helpers
import generatePath from "utils/generatePath";
import processRoutes from "utils/processRoutes";
import pseudoFormat from "utils/pseudoFormat";
import containerRoutes from "helpers/containerRoutes";

// #####################################################

const Friends = ({
	match: {
		params: { login },
	},
	route: { routes },
}) => {
	const user = useSelector((state) => state.userProfileMain);
	const { t } = useTranslation(["userProfile"]);
	const location = useLocation();

	const pathname = location?.pathname ?? "";
	const processedRoutes = processRoutes(routes);
	const finalRoutes = containerRoutes(processedRoutes, {
		login: user.login.toLowerCase(),
	});

	// #####################################################

	return (
		<CardsBlockWrapper>
			<CardWrapper>
				<CardBody>
					<Nav.Panel appearance="tabs" noLine>
						<Nav.List noPad>
							{processedRoutes.map((route) => {
								const to = generatePath(route.path, {
									login: login?.toLowerCase(),
								});
								return (
									<NavItemLink
										to={{
											pathname: to,
											state: {
												forceReload: true,
											},
										}}
										container={Nav.Item}
										key={route.key}
										isActive={() => {
											return matchPath(pathname, {
												path: route.path,
												exact: true,
											});
										}}
									>
										<Nav.Item.Content>
											<Block flex px={2}>
												{t(`userProfile:${route.key}`)}{" "}
												{pseudoFormat(
													user.statistics[
														route.meta.counterKey
													] || null
												)}
											</Block>
										</Nav.Item.Content>
									</NavItemLink>
								);
							})}
						</Nav.List>
					</Nav.Panel>
					{renderRoutes(finalRoutes)}
				</CardBody>
			</CardWrapper>
			<EmptyBlock />
		</CardsBlockWrapper>
	);
};

// #####################################################

const mapStateToProps = ({ user: { friends } }) => ({ friends });

export default connect(mapStateToProps, null)(Friends);

// #####################################################
